/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import useLocalization from './useLocalization';

export default function IntlProvider({ children }: any) {
  useLocalization();

  return <>{children}</>;
}
